;(function () {
  'use strict'

  angular.module('contrast.app').factory('GlobalService', GlobalService)

  function GlobalService() {
    'ngInject'

    var service = {
      buildLanguageSelect: buildLanguageSelect,
      setProperties: setProperties,
      setAttributeLabel: setAttributeLabel,
      getVersion: getVersion,
      getMode: getMode,
      getBuild: getBuild,
      getRelease: getRelease,
      getMaxFailedAttempts: getMaxFailedAttempts,
      getAttributeLabel: getAttributeLabel,

      getTimezone: getTimezone,
      getTimeFormat: getTimeFormat,
      getDateFormat: getDateFormat,

      getTeamserverURL: getTeamserverURL,

      setManagingUsers: setManagingUsers,
      isManagingUsers: isManagingUsers,
      getInternalVersion: getInternalVersion,
      compareVersion: compareVersion
    }

    return service

    function buildLanguageSelect(data, addEmpty) {
      var select = []
      if (addEmpty) {
        select.push({ value: '', text: 'Any' })
      }
      angular.forEach(data, function (language) {
        select.push({ value: language, text: language })
      })

      return select
    }

    function setProperties(properties) {
      this.version = properties.version

      this.internal_version = properties.internal_version
      this.mode = properties.mode
      this.build = properties.build
      this.release_notes = properties.release_notes
      this.max_failed_attempts = properties.max_failed_attempts

      this.timezone = properties.timezone
      this.time_format = properties.time_format
      this.date_format = properties.date_format

      this.teamserver_url = properties.teamserver_url
    }

    function setAttributeLabel(label) {
      this.attribute_label = label
    }

    function getVersion() {
      return this.version
    }

    function getMode() {
      return this.mode
    }

    function getBuild() {
      return this.build
    }

    function getRelease() {
      return this.release_notes
    }

    function getMaxFailedAttempts() {
      return this.max_failed_attempts
    }

    function getAttributeLabel() {
      return this.attribute_label
    }

    function getTimezone() {
      return this.timezone
    }

    function getTimeFormat() {
      return this.time_format
    }

    function getDateFormat() {
      return this.date_format
    }

    function getTeamserverURL() {
      return this.teamserver_url
    }

    function setManagingUsers(managing) {
      this.managingUsers = managing
    }

    function isManagingUsers() {
      return this.managingUsers
    }

    function getInternalVersion() {
      return this.internal_version
    }

    function compareVersion(compareVersion) {
      if (typeof this.internal_version != 'string') {
        //Compare that the type is String
        return false
      }
      if (typeof compareVersion != 'string') {
        //Compare that the type is String
        return false
      }

      var a = this.internal_version.split('.'),
        b = compareVersion.split('.'),
        i = 0,
        len = Math.max(a.length, b.length)

      for (; i < len; i++) {
        if (
          (a[i] && !b[i] && parseInt(a[i]) > 0) ||
          parseInt(a[i]) > parseInt(b[i])
        ) {
          return 1
        } else if (
          (b[i] && !a[i] && parseInt(b[i]) > 0) ||
          parseInt(a[i]) < parseInt(b[i])
        ) {
          return -1
        }
      }

      return 0
    }
  }
})()
